'use client'

import { getSchemaConstraints } from '@/components/forms/helpers/schema-constraints'
import { communityCreationSchema } from '@/components/forms/schemas/community'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

export default function NameField({ form, onEnterPress }) {
  const nameConstraints = getSchemaConstraints(communityCreationSchema, 'name')

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnterPress) {
      e.preventDefault()
      onEnterPress()
    }
  }

  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <h5 className="text-h-5-sm font-medium">Name your Community</h5>
          </FormLabel>
          <FormControl>
            <Input
              type="text"
              {...field}
              {...nameConstraints}
              placeholder="A community name"
              className="mb-3 px-6 py-4 text-p-3 font-light"
              onKeyDown={handleKeyDown}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
